module.exports = __webpack_public_path__ + "static/media/BannerRegistroMobileEN.c6673e21.jpg";